// extracted by mini-css-extract-plugin
module.exports = {"integrationLogo":"styles_integrationLogo__3y2ys"};